import Avatar from 'antd/lib/avatar'
import 'antd/lib/avatar/style/index.less'
import './styles.less'

export default Avatar
